import React, { useState, useEffect } from "react";
import { Avatar, Card, CardContent, Grid, Typography } from "@mui/material";
import { red } from "@mui/material/colors";
import Filter2Icon from "@mui/icons-material/Filter2";

const CustomSpent = (props) => {
  const [labscard, setLabscard] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/billingview/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        setLabscard(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <Card
      sx={{ height: "100%", border: 1, borderColor: "text.primary" }}
      {...props}
    >
      <CardContent>
        <Grid container spacing={3} sx={{ justifyContent: "space-between" }}>
          <Grid item>
            <Typography
              style={{ textAlign: "center" }}
              variant="h6"
              gutterBottom
              component="div"
            >
              CUSTOM
            </Typography>
            <Typography color="textSecondary" gutterBottom variant="h6">
              SPENT:
            </Typography>
            <Typography color="textPrimary" variant="h3">
              {`${labscard.custom}`}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: red[600],
                height: 56,
                width: 56,
              }}
            >
              <Filter2Icon />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CustomSpent;